import styled from '@emotion/styled';
import { mergeProps, useFocusRing } from 'react-aria';

import { Glyph } from '../../common/Glyph';
import { TextMedium } from '../../common/text/TextMedium';
import { TextSmall } from '../../common/text/TextSmall';
import { useOptionContext } from '../../list-box/ListBox';

import { su } from '../../../theme/functions/su';
import { glyph } from '../../../theme/glyph';
import { theme } from '../../../theme/theme';
import glyphStyles from '../../common/Glyph.module.css';

export function OptionDescriptive(props) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars -- intentionally unused
  const { ref, option, state, item, value } = useOptionContext();

  const focusRing = useFocusRing();

  return (
    <OptionDescriptive.Root
      {...mergeProps(option.optionProps, focusRing.focusProps)}
      ref={ref}
      className={props.className}
      style={props.style}
      as={props.as}
      data-is-selected={option.isSelected}
      data-is-focused={option.isFocused}
      data-is-pressed={option.isPressed}
      data-is-disabled={option.isDisabled}
      data-is-focus-visible={focusRing.isFocusVisible}
    >
      <OptionDescriptive.Title>{item.textValue}</OptionDescriptive.Title>
      <TextSmall color={theme.color.text_light}>{value.description}</TextSmall>

      <Glyph
        source={glyph.core.checkmark}
        color={theme.color.blue}
        size={theme.icon.size_default}
      />
    </OptionDescriptive.Root>
  );
}

OptionDescriptive.Title = styled(TextMedium)`
  padding-bottom: 5px;
`;

OptionDescriptive.Root = styled.li`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 1 ${su(5)};
  padding: ${su(1, 2)};
  outline: 0;
  cursor: pointer;

  .${glyphStyles.root} {
    position: absolute;
    right: ${su(2)};
    top: ${su(1)};
    opacity: 0;
  }

  &[data-is-selected='true'] {
    .${glyphStyles.root} {
      opacity: 1;
    }
  }

  &[data-is-disabled='true'] {
  }

  &[data-is-focused='true'] {
    background-color: ${theme.color.background_hover};
  }

  &[data-is-pressed='true'] {
  }

  &[data-is-focus-visible='true'] {
    background-color: ${theme.color.background_hover};
  }

  &:not(:last-of-type):after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background-color: ${theme.color.line};
  }
`;
